export class ScheduledTaskStatus {
  name: string;
  description: string;
  lastExecutionTime: Date | null;
  frequency: string;


  constructor(data: any) {
    this.name = data.name;
    this.description = data.description;
    this.lastExecutionTime = data.lastExecutionTime ? new Date(data.lastExecutionTime) : null;
    this.frequency = data.frequency;
  }
}
